import { render, staticRenderFns } from "./AtGoogleLogin.vue?vue&type=template&id=897d8ee8&"
import script from "./AtGoogleLogin.vue?vue&type=script&lang=js&"
export * from "./AtGoogleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports